import { render } from "./ColorBox.vue?vue&type=template&id=ef29b756&scoped=true"
const script = {}

import "./ColorBox.vue?vue&type=style&index=0&id=ef29b756&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_typescript@5.9.3__webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef29b756"]])

export default __exports__